export default "__VITE_ASSET__D6HsI7_d__"